import { createStore } from "vuex";
import { API_BASE_URL } from "../../axios";
export default createStore({
  state: {
    currentSong: "",
    currentSongLink: "",
    currentSearch: "",
    playlist: [], // Add this line
  },
  getters: {
    getCurrentSong(state) {
      return state.currentSong;
    },
    getCurrentSongLink(state) {
      return state.currentSongLink;
    },
    getCurrentPlaylist(state) {
      // Add this getter
      return state.playlist;
    },
  },
  mutations: {
    setCurrentSong(state, song) {
      state.currentSong = song;
    },
    setFirstSong(state) {
      if (state.playlist.length > 0) {
        state.currentSong = state.playlist[0];
        state.playlist.shift(); // Remove the first song from the playlist
      } else {
        state.currentSong = "";
      }
    },
    addSongToPlaylist(state, song) {
      // Create a new array with the new song added
      const newPlaylist = [...state.playlist, song];
      // Replace the old playlist with the new array
      state.playlist = newPlaylist;
    },
    setCurrentSongLink(state, link) {
      state.currentSongLink = link;
    },
    setFirstSongLink(state) {
      if (state.playlist.length > 0) {
        console.log(
          "Setting current song link to: " +
            API_BASE_URL +
            "/song/" +
            state.playlist[0].songbacktitle +
            ".wav",
        );
        state.currentSongLink =
          API_BASE_URL + "/song/" + state.playlist[0].songbacktitle + ".wav";
      } else {
        state.currentSongLink = "";
      }
    },
    setPlaylist(state, playlist) {
      // Add this mutation
      state.playlist = playlist;
    },
    setCurrentSearch(state, search) {
      state.currentSearch = search;
    },
  },
  actions: {
    updateCurrentSong({ commit }, song) {
      commit("setCurrentSong", song);
    },
    updateSongLink({ commit }, link) {
      commit("setCurrentSongLink", link);
    },
    updatePlaylist({ commit }, playlist) {
      // Add this action
      commit("setCurrentPlaylist", playlist);
    },
    updateSearch({ commit }, search) {
      commit("setCurrentSearch", search);
    },
  },
  modules: {},
});
